const QUIZ_TAKER_KEY = 'quiztaker';

const questions = require('../lib/questions');
const qUrl = process.env.NODE_ENV === 'production' ? '/can-you-spot-the-terrorist' : '';

function store(state, emitter) {
  emitter.on('quiz:nextQuestion', function() {
    const nextQuestion = questions.reduce((acc, q) => {
      if (acc === false && q.id === state.currentQuestion.id) {
        return true;
      }
      if (acc === true) {
        return q;
      }
      return acc;
    }, false);

    if (nextQuestion === true) {
      state.quiztaker.progress++;
      saveLocalQuizTaker();
      emitter.emit(state.events.PUSHSTATE, `${qUrl}/scorecard`);
    } else if (nextQuestion === false) {
      //error
    } else {
      navToQuestion(nextQuestion);
    }
  });

  emitter.on('quiz:answer', function(id, answer) {
    state.quiztaker.answers = state.quiztaker.answers.concat({
      id: id,
      chosenAnswer: answer
    });

    state.currentQuestion = Object.assign({}, state.currentQuestion, {
      chosenAnswer: answer,
      correct: state.currentQuestion.answer === answer
    });

    saveLocalQuizTaker();
    emitter.emit(state.events.RENDER);
  });

  emitter.on('quiz:start', () => {
    state.quiztaker.isEmbeddedQuiz = state.query.embed;
    navToQuestion(questions[0]);
  });

  emitter.on('quiz:route-intro', () => {
    emitter.emit(state.events.PUSHSTATE, `${qUrl}/`);
  });

  emitter.on('navigate', () => {
    // if (state.params.questionNumber) {
    //   // check for an answer for this question if so show the answer page... else do nothing.
    //   let question = state.questions.filter(
    //     q => q.id === state.params.questionNumber
    //   )[0];
    //   let answer = state.quiztaker.answers.filter(
    //     a => a.id === state.params.questionNumber
    //   )[0];
    //   if (question && answer) {
    //     state.currentQuestion = Object.assign({}, question, {
    //       chosenAnswer: answer.chosenAnswer,
    //       correct: question.answer === answer.chosenAnswer
    //     });
    //     emitter.emit(state.events.PUSHSTATE, `/question/${question.id}`);
    //   }
    // }
  });

  emitter.on('retake-quiz', () => {
    const urlToGo = state.quiztaker.isEmbeddedQuiz
      ? qUrl + '/?embed=true'
      : qUrl + '/';

    localStorage.clear();
    initState();

    emitter.emit(state.events.PUSHSTATE, urlToGo);
  });

  emitter.on('DOMContentLoaded', function() {});

  function saveLocalQuizTaker() {
    window.localStorage.setItem(
      QUIZ_TAKER_KEY,
      JSON.stringify(state.quiztaker)
    );
  }

  function navToQuestion(nextQuestion) {
    state.currentQuestion = nextQuestion;
    state.quiztaker.progress++;
    saveLocalQuizTaker();
    emitter.emit(state.events.PUSHSTATE, `${qUrl}/question/${nextQuestion.id}`);
  }

  function checkPlace() {
    if (state.quiztaker.progress > 0) {
      if (state.quiztaker.progress - 1 === state.questions.length) {
        emitter.emit(state.events.PUSHSTATE, `${qUrl}/scorecard`);
      } else {
        state.currentQuestion = state.questions[state.quiztaker.progress - 1];

        emitter.emit(
          state.events.PUSHSTATE,
          `${qUrl}/question/${state.currentQuestion.id}`
        );
      }
    }
  }

  function loadLocalQuizTaker() {
    let quiztaker;
    const QUIZ_TAKER_KEY = 'quiztaker';
    try {
      quiztaker = JSON.parse(window.localStorage.getItem(QUIZ_TAKER_KEY));
    } catch (error) {
      quiztaker = {
        progress: 0,
        answers: []
      };
    }

    return (
      quiztaker || {
        progress: 0,
        answers: []
      }
    );
  }

  function initState() {
    state.questions = questions;
    state.currentQuestion = null;
    state.quiztaker = loadLocalQuizTaker();
  }

  initState();
  checkPlace();
}

module.exports = store;
